import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Grid
} from "@mui/material";
import { FiMenu } from "react-icons/fi";
import { useTheme } from "@mui/material/styles";
import ProjectLogo from "../../Assets/Images/Login/PSCAdminPortalLogin.svg";
import { TransparentColorButton, GreenColorButton } from "../MaterialButtonStyle/StyleButton";

const LandingPageHeader = ({ homeRef, jobsRef }) => {

  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setDrawerOpen(open);
  };

  const menuItems = [
    { label: "Home", href: location.pathname == "/" ? homeRef : "/" },
    { label: "About Us", href: "https://psc.gov.ng/about/" },
    { label: "The Commission", href: location.pathname == "/" ? jobsRef : "/" },
    { label: "Departments", href: location.pathname == "/" ? jobsRef : "/" },
    { label: "News/Press Release", href: "https://psc.gov.ng/news/" },
    { label: "Activities of the Commission", href: "https://psc.gov.ng/" },
    { label: "Contact Us", href: "https://psc.gov.ng/contact/" },
  ];

  const ScrollToSection = (ref, type) => {
    if ((type == "Home") || (type == "The Commission") || (type == "Departments")) {
      if (location.pathname == "/") {
        ref.current.scrollIntoView({ behavior: "smooth" });
      }
      else {
        navigate("/");
      }
    }
    else {
      window.open(ref, "_blank");
    }
  };

  return (
    <AppBar position={location.pathname == "/" ? "fixed" : "static"} sx={{ backgroundColor: "#333333", height: "12vh" }}>
      {/* Desktop Menu */}
      {!isMobile && (
        <Grid item container lg={12} md={12} sm={12} xs={12} padding={"0% 2%"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
          <Grid item container lg={1.5} md={1.5} sm={1.5} xs={1.5}>
            <img
              src={ProjectLogo}
              alt="ProjectLogo"
              role="presentation"
              className="pointer"
              onClick={() => navigate("/")}
              style={{ width: 60, height: 60, marginRight: 8 }}
            />
          </Grid>
          <Grid item container lg={9} md={9} sm={9} xs={9} justifyContent={"space-between"}>
            {menuItems.map((item) => (
              <TransparentColorButton key={item.label} onClick={() => ScrollToSection(item.href, item.label)}>
                {item.label}
              </TransparentColorButton>
            ))}
          </Grid>
          {location.pathname == "/" ?
            <Grid item container lg={1.5} md={1.5} sm={1.5} xs={1.5} justifyContent={"flex-end"}>
              <GreenColorButton className="px-4 py-1" sx={{ borderRadius: "4px" }} onClick={() => navigate("/candidatelogin")}>
                Login
              </GreenColorButton>
            </Grid>
            : ""}
        </Grid>
      )}
      {/* Mobile Menu */}
      {isMobile && (
        <>
          <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box display="flex" alignItems="center">
              <img
                src={ProjectLogo}
                alt="Project Logo"
                style={{ width: 60, height: 60, marginRight: 8 }}
              />
            </Box>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
            >
              <FiMenu color={"#fff"} />
            </IconButton>
            <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
              <Box
                sx={{ width: 250 }}
                role="presentation"
                onClick={toggleDrawer(false)}
                onKeyDown={toggleDrawer(false)}
              >
                <List>
                  {menuItems.map((item) => (
                    <ListItem button key={item.label} component="a" onClick={() => ScrollToSection(item.href, item.label)}>
                      <ListItemText primary={item.label} />
                    </ListItem>
                  ))}
                  {location.pathname == "/" ?
                    <ListItem button>
                      <GreenColorButton className="px-4 py-1" sx={{ borderRadius: "4px" }} onClick={() => navigate("/candidatelogin")}>
                        Login
                      </GreenColorButton>
                    </ListItem>
                    : ""}
                </List>
              </Box>
            </Drawer>
          </Toolbar>
        </>
      )}
    </AppBar>
  );
};

export default LandingPageHeader;
